<template>
  <div>
    <b-modal
      :title="title"
      size="xl"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <div v-if="type !== 3" class="operate">
        <div class="search">
          <template v-if="type === 1">
            <b-form-group label-cols="auto" label-cols-lg="auto" label="期別(民國年月份)">
              <roc-date-picker-year-month
                v-model="search.period"
                @dateChange="getDisplayMember(1)" />
            </b-form-group>
          </template>

          <template v-else>
            <date-picker
              v-model="search.start_date"
              :position="'right'"
              placeholder="開始日期"
            ></date-picker>

            <date-picker
              v-model="search.end_date"
              :position="'right'"
              placeholder="結束日期"
            ></date-picker>
          </template>
        </div>

        <div class="btn-area">
          <div class="btn-function">
            <b-button variant="danger" @click="resetSearch()">重置</b-button>

            <b-button variant="success" @click="getViewApi(1)">搜尋</b-button>
          </div>
        </div>
      </div>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
        :pageData="page"
        v-on:result="getViewApi"
      >
        <template #cell(pay_name)="row">
          {{ isMaskData ? maskData(row.item.pay_name, 'name') : row.item.pay_name }}
        </template>

        <template #cell(member_name)="row">
          {{ isMaskData ? maskData(row.item.member_name, 'name') : row.item.member_name }}
        </template>

        <template #cell(member_ID_number)="row">
          {{ isMaskData ? maskData(row.item.member_ID_number, 'ID') : row.item.member_ID_number }}
        </template>
        <template #cell(join_date)="row">
          {{ convertRocDate(row.item.join_date) }}
        </template>
      </tables-page>
      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import { convertRocDate, maskData, countNoNum } from "@/models/HELPERS/common.js";
import datePicker from '@/components/common/DatePicker';
import RocDatePickerYearMonth from "@/components/common/RocDatePickerYearMonth";

export default {
  name: 'FakeListModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true,
      default: '互助名單'
    },
    plan: {
      type: String,
      required: true,
      default: 'A'
    },
    type: {
      type: Number,
      required: true,
      default: 0
    },
    isMaskData: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage,
    datePicker,
    RocDatePickerYearMonth
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "plan",
          label: "組別",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "pay_name",
          label: "要助人",
          sortable: true
        },
        {
          key: "member_name",
          label: "互助人",
        },
        {
          key: "member_ID_number",
          label: "互助人身分證",
        },
        {
          key: "join_date",
          label: "生效日期",
        }
      ],
      search: {
        start_date: '',
        end_date: '',
        period: ''
      },
      table_data: [],
      page: {}
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.resetSearch(false);

         this.getViewApi(1);
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();

    this.load();
  },
  methods: {
    convertRocDate,
    maskData,
    // 首次載入讀取
    load() {
      this.page = Object.assign({}, this.contractApi.page);
    },
    getViewApi(pageIndex = null) {
      if (this.type !== 3) {
        this.getDisplayMember(pageIndex);
      } else {
        this.getMember(pageIndex);
      }
    },
    // 查詢假名單
    getDisplayMember(pageIndex = null) {
      this.status.isLoading = true;
      const currentPage = pageIndex ? pageIndex : this.page.pageIndex;
      this.page.pageIndex = currentPage;

      const params = {
        ...this.search,
        'type': this.type,
        'plan': this.plan,
        'PageSize': this.page.pageSize,
        'PageIndex': currentPage,
      };

      this.contractApi.getDisplayMember((response) => {
        const res = response.data;

        this.page.totalCount = res.count_total; // 總筆數
        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: countNoNum(this.page, index)
          }
        });

        this.status.isLoading = false;
      }, params, false)
    },
    // 查詢額滿名單
    getMember(pageIndex = null) {
      this.status.isLoading = true;

      const params = {
        'number': this.plan,
        'type': 0,
        'pay_off_status': 1,
        'status': 0,
        'PageSize': this.page.pageSize,
        'PageIndex': pageIndex ? pageIndex : this.page.pageIndex,
      };
      this.contractApi.getMember((response) => {
        const res = response.data;

        this.page.totalCount = res.total; // 總筆數
        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: countNoNum(this.page, index)
          }
        });

        this.status.isLoading = false;
      }, params, false)
    },
    // 重置欄位，並搜尋
    resetSearch(is_call_api = true) {
      this.search = {
        start_date: '',
        end_date: '',
        period: ''
      }

      if (is_call_api) this.getViewApi(1);
    },
  }
}
</script>

<style lang="scss" scoped>
.operate {
  display: flex;
  white-space: nowrap;
  margin-bottom: 20px;
  column-gap: 20px;
  .search {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    flex-basis: 80%;
    .blur {
      display: inline-flex;
      align-items: center;
      justify-content: space-between;
      column-gap: 10px;
      .blur-info {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 1.2rem;
        height: 1.2rem;
        border-radius: 50%;
        font-size: 12px;
        background: #17A2B8;
        color: #FFF;
      }
    }
  }
  .btn-area {
    flex-basis: 20%;
    .btn-function {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Modal/FakeListModal.vue